import { Injectable, signal } from '@angular/core';
 
@Injectable({
  providedIn: 'root',
})
export class ProfileService {
 
  profileImage = signal<string | undefined>(
    localStorage.getItem('profileImage') ?? undefined
  );
 
    setProfileImage(image:string)
    {
      this.profileImage.set(image)
      localStorage.setItem('profileImage',image)
    }
    removeProfileImage()
    {
      this.profileImage.set(undefined)
      localStorage.removeItem('profileImage')
    }
 
}